export default "__VITE_ASSET__BvCwJZm$__"